import script from "./videoscreen.vue?vue&type=script&setup=true&lang=js"
export * from "./videoscreen.vue?vue&type=script&setup=true&lang=js"

import "./videoscreen.vue?vue&type=style&index=0&id=c4a74d16&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4a74d16"]])

export default __exports__